import UnifiedSkybus from "@skydio/skybus/src/unified";
import SkybusProviderLog from "@skydio/skybus/src/provider/log";
import WebSocketConnector from "@skydio/skybus/src/transport/websocket/websocket_connector";

import { TELEMETRY_API_ERROR_PB } from "@skydio/channels/src/telemetry_api_error_pb";

import { telemetry_error_code_t } from "@skydio/lcm/types/telemetry_api/telemetry_error_code_t";

export const setupWebsocketErrorChannel = (
  websocketConnector: WebSocketConnector,
  onError: (code: number, errorName: string) => void
) => {
  // NOTE(danny): replace the onMessage handler on the websocket connector to intercept errors
  const skybusLogOnMessage = websocketConnector.handleMessage;
  websocketConnector.handleMessage = (channel: string, encodedMsg: Uint8Array) => {
    if (channel === TELEMETRY_API_ERROR_PB.channel) {
      const msg = TELEMETRY_API_ERROR_PB.type(encodedMsg);
      const errorName = telemetry_error_code_t.option_t[msg.getCode()]!;

      onError(msg.getCode(), errorName);
      return true;
    }

    return skybusLogOnMessage(channel, encodedMsg);
  };
};

export interface OnConnectArgs {
  skybus?: UnifiedSkybus;
  provider?: SkybusProviderLog;
}
